import { createContext, PropsWithChildren, useContext } from 'react';
import { mergeProps } from '@react-aria/utils';
import { ButtonContext as AriaButtonContext } from 'react-aria-components';

import { ButtonProps } from './Button';

export type ButtonContextProps = Pick<ButtonProps, 'onPress' | 'onHoverStart' | 'onHoverEnd' | 'isLoading' | 'isDisabled'>;

// eslint-disable-next-line react-refresh/only-export-components
export const ButtonContext = createContext<ButtonContextProps | undefined>(undefined);

export const ButtonContextProvider = ({ children, value }: PropsWithChildren<{ value: ButtonContextProps }>) => {
  let childContextValue = value;

  const parent = useContext(ButtonContext);

  if (parent) {
    childContextValue = mergeProps(parent, childContextValue);
  }

  return (
    <ButtonContext.Provider value={childContextValue}>
      <AriaButtonContext.Provider value={childContextValue}>{children}</AriaButtonContext.Provider>
    </ButtonContext.Provider>
  );
};
